import React, { useState, useEffect } from 'react';

import EthereumAddressTextField from '../component/EthereumAddressTextField';
import FieldSetFormControl from '../component/FieldSetFormControl';

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

import { ethers } from 'ethers';

function AddressChecksum (props) {
  const {
    ...other
  } = props;

  const [ address, setAddress ] = useState ('');
  const [ checksummedAddress, setChecksummedAddress ] = useState ('');

  useEffect (() => {
    try {
      setChecksummedAddress (ethers.utils.getAddress (address.trim ().toLowerCase ()));
    } catch (error) {
      setChecksummedAddress ('');
    }
  }, [ address ]);

  return (
    <Box my={-1}
         component={FieldSetFormControl}
         fullWidth
         {...other}>
      <Box my={1}
           component={EthereumAddressTextField}
           label="Address"
           value={address}
           onChange={event => setAddress (event.target.value)} />
      <Box mt={1}
           mb={3}>
        <Divider />
      </Box>
      <Box my={1}
           component={EthereumAddressTextField}
           label="Checksummed address"
           readOnly
           value={checksummedAddress} />
    </Box>
  );
}

export default AddressChecksum;
